import { render, staticRenderFns } from "./DetailRelation.vue?vue&type=template&id=6c9f5fa2&"
import script from "./DetailRelation.vue?vue&type=script&lang=js&"
export * from "./DetailRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports